import Element, { ElementType, SpecyficType } from './element';
import store from '@/store';
import { ElementMenuItem } from './elementMenuItem';
import { Vector2 } from '@babylonjs/core';
import { BaseShape } from './IShape';

export class FurnitureManager {

    private get elements(): Element[] {
        return store.getters.scene.elements;
    }

    private get body(): Element {
        return this.elements.find((x) => x.type === ElementType.BODY)!;
    }

    public hasFrontInDrawerArea(): boolean {
        const fronts = this.fronts;
        return fronts.some((x) => x.position.y - x.shape.y / 2 <= 1.5);
    }

    public hasDrawer(): boolean {
        return this.elements.some((x) => x.specyficType === SpecyficType.DRAWER);
    }

    public hasUncoveredVerticalWall(front: ElementMenuItem): boolean {
        const fronts = this.fronts;
        const verticalWalls = this.verticalWalls;
        const offsetX = (front.shape.x - 1) / 2;
        const offsetY = 0.5 * (front.shape.y - 1);
        for (let i = 1 + offsetX; i <= this.body.shape.x - offsetX; i++) {
            for (let j = 1 + offsetY; j <= this.body.shape.y - offsetY; j++) {
                const position = new Vector2(i, j);
                const testShape = new BaseShape(position, front.shape);
                if (
                    !fronts.some((x) => x.collide(testShape)) &&
                    verticalWalls.some((x) => x.collide(testShape))) {
                    return true;
                }
            }
        }
        return false;
    }

    public hasUncoveredHorizontalWall(front: ElementMenuItem): boolean {
        const fronts = this.fronts;
        const horizontalwalls = this.horizontalwalls;
        const offsetX = (front.shape.x - 1) / 2;
        const offsetY = 0.5 * (front.shape.y - 1);
        for (let i = 1 + offsetX; i <= this.body.shape.x - offsetX; i++) {
            for (let j = 1 + offsetY; j <= this.body.shape.y - offsetY; j++) {
                const position = new Vector2(i, j);
                const testShape = new BaseShape(position, front.shape);
                if (
                    !fronts.some((x) => x.collide(testShape)) &&
                    horizontalwalls.some((x) => x.collide(testShape))) {
                    return true;
                }
            }
        }
        return false;
    }

    public hasUncoveredShelf(element: ElementMenuItem | undefined = undefined): boolean {
        const shelfs = element === undefined ?
            this.shelfs :
            this.shelfs.filter((x) =>
                x.shape.x === element.shape.x,
            );
        const fronts = this.fronts;
        return !shelfs.every((x) => fronts.some((y) => x.inside(y)));
    }

    public get fronts(): Element[] {
        return this.elements.filter((x) => x.type === ElementType.FRONT);
    }

    public get shelfs(): Element[] {
        return this.elements.filter((x) => x.specyficType === SpecyficType.SHELF);
    }

    public get verticalWalls(): Element[] {
        return this.elements.filter((x) => x.specyficType === SpecyficType.VERTICAL_WALL);
    }

    public get horizontalwalls(): Element[] {
        return this.elements.filter((x) => x.specyficType === SpecyficType.HORIZONTAL_WALL);
    }

    public get walls(): Element[] {
        return this.elements.filter((x) => x.type === ElementType.WALL);
    }

    public get legs(): Element[] {
        return this.elements.filter((x) =>
            x.type === ElementType.LEGS &&
            x.shaderName !== 'ShaderNPodp'
        );
    }

    public get bedHead(): Element[] {
        return this.elements.filter((x) =>
            x.type === ElementType.BEDHEAD,
        );
    }
}
